import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qpub74vn67: FaireBrandEntity = {
  token: "b_qpub74vn67",
  type: "brand",
  name: "Secret Synergy Stones",
  avatarUrl:
    "https://cdn.faire.com/fastly/618ed23a42ea537957eeed7f3476da35a3c8221d2d88516c44a8305d439e93e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b492f57234214688a93e557f5176cf6782d5d70876be99a0c3f7b70e462ae538.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/618ed23a42ea537957eeed7f3476da35a3c8221d2d88516c44a8305d439e93e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b492f57234214688a93e557f5176cf6782d5d70876be99a0c3f7b70e462ae538.jpeg",
  location: "Tehachapi, CA, USA",
  minimumOrderDollars: 208,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Howdy! Shelly Black here. I design clever creations to help improve your quality of life! \n\nHere I have available EMF 5G WiFi protection jewelry for People & Pets.  What makes my jewelry unique ~ is that it actually helps you feel better, have less anxiety, less headaches & it even improves your REM sleep!!   How?? \n\nMy jewelry & art shield you from EMF WiFi radiation exposures ~ which we are engulfed in and surrounded by 24/7!\n\nNow you can proactively protect your entire family (and pets) ~ all while enjoying artisan wears that are attractive, fun AND effective!\n\nYou don't know how good you can feel ~ until you do!!!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.809Z",
    importedBy: "entity-db-cli",
  },
};
